import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import Check from '@mui/icons-material/Check'
import Close from '@mui/icons-material/Close'
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline'
import React, {useCallback, useEffect, useRef, useState} from 'react'
import SignatureCanvas from 'react-signature-canvas'
import {log} from 'common/log';

const DEFAULT_MIMETYPE = 'image/png';

const aspectRatio = 3;

const calcSize = (height = 600, width = 900) => {
	height = Math.min(height, window.innerHeight - 140);
	width = Math.min(width * aspectRatio, window.innerWidth - 50);
	if (height > width / aspectRatio) {
		height = Math.floor(width / aspectRatio);
	} else {
		width = Math.floor(height * aspectRatio);
	}
	return {height, width};
};

interface Props {
	open: boolean
	onChange: (v: { mimeType: string, data: string } | null) => void
	handleClose: () => void
}

export const SignatureCanvasPopoutComponent = React.memo<Props>(({open, onChange, handleClose}) => {
	const [size, setSize] = useState(calcSize());
	const refCanvas = useRef<SignatureCanvas>(null);

	const clear = useCallback(() =>
			refCanvas.current && refCanvas.current?.clear(),
		[refCanvas.current]);

	const done = useCallback(() => {
		if (refCanvas.current && refCanvas.current.isEmpty()) {
			onChange(null);
		} else {
			const dataUrl = refCanvas.current?.toDataURL(DEFAULT_MIMETYPE)
			const data = dataUrl && dataUrl.substr(dataUrl.lastIndexOf(',') + 1) || ''
			const mimeType = dataUrl && dataUrl.substring(dataUrl.indexOf(':') + 1, dataUrl.indexOf(';')).trim() || ''
			if (mimeType !== DEFAULT_MIMETYPE) {
				log.error("Signature Canvas delivered other mimeType than preferred: " + mimeType);
				// log.info('size of content', getSizeFromBase64(data));
			}
			onChange({mimeType, data});
		}
		handleClose();
	}, [refCanvas.current, handleClose]);

	useEffect(() => {
		const handleResize = () => setSize(calcSize());
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	});

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			fullScreen={true}
			aria-labelledby="SignatureCanvasPopoutComponent"
			style={{zIndex: 50001}}
		>
			<DialogContent style={{
				textAlign: 'center',
			}}>
				<DialogContentText>
					Bitte im markierten Bereich unterschreiben.
				</DialogContentText>
				<div style={{
					border: '2px solid #757575',
					display: 'inline-block',
				}}>
					<SignatureCanvas
						ref={refCanvas}
						backgroundColor={'#ffffff'}
						canvasProps={size}
					/>
				</div>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={clear}>
					<RemoveCircleOutline/>
					&nbsp;
					Neu
				</Button>
				<Button variant="outlined" onClick={done}>
					<Check style={{color: 'green'}}/>
					&nbsp;
					Fertig
				</Button>
				<Button variant="outlined" onClick={handleClose}>
					<Close style={{color: 'red'}}/>
					&nbsp;
					Abbrechen
				</Button>
			</DialogActions>
		</Dialog>
	);
});
